import BaseApi from "./BaseApi";

export default class ActuatorApi extends BaseApi {
  static checkHealth = () => this.get(`actuator/health`);
}
